exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.color__picker[data-v-7b78a4d5]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/website_prod/src/components/global/ColorPicker.vue"],"names":[],"mappings":";AAwBA,gCACI,oBAAA,oBAAA,aACA,yBAAA,sBAAA,kBAAmB;CACtB","file":"ColorPicker.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.color__picker {\n    display: flex;\n    align-items: center;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7b78a4d5","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/global/ColorPicker.vue
// module id = tggJ
// module chunks = 1